import { CloseCircleFilled, CloseOutlined, LockOutlined, UserOutlined } from "@ant-design/icons"
import { Checkbox, Form, FormInstance, FormProps, Input } from "antd"
import { useForm } from "antd/lib/form/Form"
import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { getListGroup } from "../../api/groupCustomerV2/groupCustomerV2Api"
import * as loginApi from "../../api/login/loginApi"
import { Logo_THACOAUTO } from "../../components/ExportImgFigma"
import { ModalPermission } from "../../components/Modal/ModalPermission"
import useInfoUser from "../../hook/useInfoUser"
import useThrottle from "../../hook/useThrottle"
import tokenService from '../../services/token'
import { setGroupCustumer } from "../../store/slices/groupCustumerSlice"
import { selectorDataAcccount } from "../../store/slices/userSlice"
import { getDeepestFirstChildUrl, gListUnitByUserPermission, setMenuAndPermission } from "../../until"
import './style.scss'
import { selectorMenu, selectorMenuIsReady } from "../../store/slices/menuSlice"
import useLoading from "../../hook/useLoading"
import { selectLoading } from "../../store/slices/loadingSlice"
import { selectorCategoryCarIds } from "../../store/slices/categoryCarSlice"
import { setSourceColumnWarehouse } from '../../store/slices/sourceColumnWarehouseSlice';
import { mixGetSourceColumnWarehouses } from "../../services/mixin"
import { getInfoWorkSession } from "../../api/workSessionSetting/workSessionSettingApi"
import { ModalPermissionLogin } from "../../components/Modal/ModalPermissionLogin"

const Login: React.FC = () => {

  useEffect(() => {

    if (isMenuReadySlice) navigate(-1)

    return (() => {
      setIsSaveAccount(false)
      setIsMesseageError(false)
      setMesseageError("")
      setEnableLogin(false)

      setPassword("")
    })
  }, []);

  const [form] = useForm();
  const inputRef = useRef<FormInstance>(null);

  const isLoading = useSelector(selectLoading)
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const pushLoading = useLoading()
  const dataAcccount = useSelector(selectorDataAcccount)
   const menuSlice = useSelector(selectorMenu)
  const isMenuReadySlice = useSelector(selectorMenuIsReady)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const { setInfoUserData, setTimeSessionTimeout, setAccountPasswordUser, clearAccountPasswordUser, setPermissionData } = useInfoUser()




  const [isSaveAccount, setIsSaveAccount] = useState(false)
  const [isMesseageError, setIsMesseageError] = useState(false)
  const [messeageError, setMesseageError] = useState("")
  const [enableLogin, setEnableLogin] = useState(false);
  const [showModalPermission, setShowModalPermission] = useState(false);
  const [showModalForgotPassword, setShowModalForgotPassword] = useState(false);

  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');


  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.target.value);
    updateEnableLogin(e.target.value, password);
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    updateEnableLogin(username, e.target.value);
  };

  const updateEnableLogin = (user: string, pass: string) => {
    setEnableLogin(user.trim() !== '' && pass.trim() !== '');
  };

  // menu


  const gListGroupCustomer = async () => {
    const result = await getListGroup(
      permittedCategoryCarIds,
      undefined, undefined, undefined, undefined, undefined, 2
    )
    if (result?.status) {
      dispatch(setGroupCustumer(result?.data))
    } else {
    }
  }


  //permission
  // const gPermissionUser = async (unitId: number, groupPermissionId?: number) => {
  //   const result = await loginApi.permissionUser(unitId, groupPermissionId)
  //   if (result?.status) {
  //     dispatch(setPermission(result.dataMenu))
  //   }
  // }
  // danh sách đơn vị đc cấp quyền sử dụng


const setDataUser = async (token: string, data: loginApi.IUser) => {
    setInfoUserData(data)
    if (isSaveAccount) {
      setAccountPasswordUser(username, password)
    } else {
      clearAccountPasswordUser()
    }
    tokenService.setToken(token)

    setMenuAndPermission(data.unit, dispatch, navigate, location.pathname)

    //tg đăng xuât
    const result = await getInfoWorkSession()
    if (result?.status) {
      setTimeSessionTimeout(result.data.sessionTimeout)
    }

    //chuẩn
    gListGroupCustomer()
    const obData = await mixGetSourceColumnWarehouses()
    dispatch(setSourceColumnWarehouse(obData))
  }

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const onFinish: FormProps["onFinish"] = useThrottle(async (values: any) => {
    setUsername(values.username)
    setPassword(values.password)
    pushLoading(true)
    const result = await loginApi.login(values.username, values.password)
    if (result?.status && result?.data.groupPermission !== null) {
      // setDataPermission(result.token, result.dataMenu)
      // gPermissionUser(result.data.unit, result.data.groupPermission)
      gListUnitByUserPermission(result.data.id, dispatch)
      setDataUser(result.token, result.data)
    } else {
      setMesseageError("Đăng nhập không thành công. Tài khoản chưa được cấp quyền")
      setIsMesseageError(true)
      setShowModalPermission(true)
    }
    pushLoading(false)
  }, 1000)



  useEffect(() => {

    if (tokenService.getToken()&& isMenuReadySlice) {
      navigate(`${getDeepestFirstChildUrl(menuSlice)}`)
      // navigate(`/customer/list`)
    }
    if (dataAcccount.username !== "") {
      setIsSaveAccount(true)
      setEnableLogin(true)
      setUsername(dataAcccount.username)
      setPassword(dataAcccount.password)
      form.setFieldsValue({
        "username": dataAcccount.username,
        "password": dataAcccount.password
      })
    }
  }, [dataAcccount, navigate]);




  return (
    <div className=" h-100vh d-flex items-center overflow-hidden">
      <ModalPermissionLogin
        isOpen={showModalPermission}
        title="Yêu cầu cấp quyền truy cập"
        content=""
        closeModal={() => setShowModalPermission(false)}
      />
      <ModalPermission
        isOpen={showModalForgotPassword}
        title="Quên mật khẩu"
        content="cấp lại mật khẩu"
        closeModal={() => setShowModalForgotPassword(false)}
      />
      <div className="bg-login d-flex align-center">
        <div className=" d-flex flex-column justify-between pl-110-px">
          <div className=" d-flex flex-column ">
            {/* <img src='/images/exportImg/logo_thaco.svg' alt="" className="w-544-px h-120-px" /> */}
            <img src={Logo_THACOAUTO} alt="" className="w-544-px h-120-px" />
            {/* <img src='https://bdata.vn/img/bdata-logo-new-2.png' alt="" className="w-544-px" /> */}
            {/* <img src={logo_Bdata} alt="" className="w-544-px" /> */}
            <div>
              <span className="text-11 fw-600 font-regular text-white line-height-normal">Hệ Thống Quản Lý <br />Quan hệ khách hàng</span>
            </div>
          </div>

        </div>
      </div>
      <div className="h-100vh d-flex  align-center pl-58-px">
        <Form
          form={form}
          ref={inputRef}
          onFinish={onFinish}
          initialValues={{ remember: true }}
          className="bg-form-login d-flex  align-center"
        >
          <div className="w-364-px d-flex flex-column gap-6">
            <div className="d-flex flex-column gap-5">
              <span className="text-30-px font-medium fw-500">Đăng nhập</span>
              <div
                className={` ${isMesseageError ? 'd-flex align-center rounded-1 border-FFCCD2 bg-FEF2F2 h-57-px' : 'none'}`}
              >
                <div className="d-flex gap-3 align-baseline" >
                  <CloseCircleFilled className="text-sm text-F64C4C pl-3 overflow-auto" />
                  <p className="text-sm text-1F1F1F font-regular fw-400">{messeageError}</p>
                </div>
                <CloseOutlined className="text-sm text-8E8E8E pr-3 cursor-pointer" onClick={() => setIsMesseageError(false)} />
              </div>
              <div className="d-flex flex-column gap-4">
                <Form.Item
                  name="username"
                  rules={[
                    { required: true, message: 'Nhập tên đăng nhập hoặc email!' },
                    { min: 4, message: 'Tối thiểu 4 ký tự' },
                  ]}
                  className="m-none-form-item text-explan"
                >

                  <Input
                    maxLength={40}
                    prefix={<UserOutlined />}
                    placeholder="Tên đăng nhập hoặc email"
                    className='rs-input '
                    onChange={handleUsernameChange}
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: 'Nhập mật khẩu của bạn!' },
                    { min: 4, message: 'Tối thiểu 4 ký tự' },
                  ]}
                  className="m-none-form-item text-explan"
                >

                  <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="Mật khẩu của bạn"
                    autoComplete="new-password"
                    className="rs-input"
                    maxLength={20}
                    onChange={handlePasswordChange}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="d-flex justify-between align-center">
              <Checkbox
                className="size-check-box size-check-box-inner p-checkbox icon-check-box"
                checked={isSaveAccount}
                onChange={(e) => setIsSaveAccount(!isSaveAccount)}
              >
                <span className="text-sm font-regular fw-400"
                >Lưu tài khoản
                </span>
              </Checkbox>
              <span
                className="text-base fw-400 font-regular text-1890FF cursor-pointer"
                onClick={() => setShowModalForgotPassword(true)}
              >
                Lấy lại mật khẩu
              </span>
            </div>
            <button
              className={`w-full h-38-px  rounded-2 text-base font-regular fw-400 ${!enableLogin ? 'bg-F5F5F5 text-98A2B3 border-EAECF0 shadow-login' : 'shadow-active bg-1890FF text-white border-none'}`}
              disabled={!enableLogin || isLoading}
              onClick={submitForm}
            >
              Đăng nhập
            </button>
          </div>
        </Form>

      </div>
    </div>
  )
}
export default Login
